














































































import Vue from 'vue';

export default Vue.extend({
  auth: true,
  data: () => ({
    date: Vue.$date.now().format('YYYY-MM-DD'),
    profileMenuVisible: false,
    isSidedrawerVisible: true,
  }),
  beforeMount() {
    this.isSidedrawerVisible = this.$localStorage.get<boolean>('isSidedrawerVisible') ?? true;
  },
  methods: {
    async doLogoff() {
      try {
        await this.$auth.logout();
        this.$router.push('/_exterior/login');
      } catch (error) {
        Vue.$log.error('Unable to log out an error occurred');
        Vue.$log.error(error);
      }
    },
    toggleSideDrawerVisible() {
      this.isSidedrawerVisible = !this.isSidedrawerVisible;
      this.$localStorage.set('isSidedrawerVisible', this.isSidedrawerVisible);
    },
  },
});
